var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Header',{attrs:{"isHome":true}}),_c('Banner',{staticStyle:{"width":"100vw","height":"100vh"}}),_c('News'),_c('Discussion'),_c('Supplier'),_c('Solutions'),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }